import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import vuecookie from 'vue-cookies'
import { clientShortName } from '@/helpers/clientShortName.js'
import { backendUrl } from '@/helpers/backendUrl.js'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/portal',
      alias: '/home',
      name: 'portal',
      component: () => import('./views/Portal.vue'),
      meta:{
          requireAuth: true
      }
    },
    {
      path: '/registration_required',
      name: 'registration_required',
      component: () => import('./views/RegistrationRequired.vue')
    },
    {
      path: '/',
      alias: '/login',
      name: 'login',
      component: () => import('./views/LogIn.vue'),
      meta:{
        requireAuth: false
      }
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import('./views/Authentication/Signup.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/newsnet_login',
      alias: ['/login/newsnet'],
      name: 'newsnetLogin',
      component: () => import('./views/LogIn.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import('./views/FAQ.vue'),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/terms',
      name: 'terms',
      component: () => import('./views/Terms.vue')
    },
    {
      path: '/link_accounts',
      name: 'link_accounts',
      component: () => import('./views/MatchingAccounts.vue'),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/delivery_rules',
      name: 'delivery_rules',
      component: () => import('./views/DeliveryRulesScreen.vue'),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('./views/Register.vue'),
      meta:{
        requireAuth: false
      }
    },
    {
      path: '/sso/registration',
      name: 'ssoRegistration',
      component: () => import('./views/sso/SsoRegistration.vue'),
      meta:{
        requireAuth: false
      }
    },
    {
      path: '/sso/already_registered',
      name: 'ssoAlreadyRegistered',
      component: () => import('./views/sso/SsoAlreadyRegistered.vue'),
      meta:{
        requireAuth: false
      }
    },
    {
      path: '/sso/registration_success',
      name: 'ssoRegistrationSuccess',
      component: () => import('./views/sso/SsoRegistrationSuccess.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/user_exists',
      name: 'user_exists',
      component: () => import('./views/UserExists.vue')
    },
    {
      path: '/forgot_password',
      name: 'forgot_password',
      component: () => import('./views/ForgotPassword.vue')
    },
    {
      path: '/require_registration',
      name: 'require_registration',
      component: () => import('./views/RegistrationRequired.vue'),
      meta:{
        requirePermission: true
      }
    },
    {
      path: '/password_reset/:token',
      name: 'password_reset',
      component: () => import ('./views/PasswordReset.vue')
    },
    {
      path: '/development',
      name: 'development',
      component: () => import ('./views/Development.vue'),
      children: [
        {
          path: 'core_types',
          name: 'core_types',
          component: () => import ('./views/CoreTypes.vue'),
          props: (route) => ({
            addBatchType: route.query.batchType
          }),
          meta:{
            requireAuth: true
          }
        },
        {
          path: 'core_types/info_batch_type',
          name: 'core_types_info_batch_type',
          component: () => import ('./components/Core_Types/InfoBatchType.vue'),
          meta:{
            requireAuth: true,
            parent: 'core_types'
          }
        },
        {
          path: 'core_types/info_document_type',
          name: 'core_types_info_document_type',
          component: () => import ('./components/Core_Types/InfoDocumentType.vue'),
          meta:{
            requireAuth: true,
            parent: 'core_types'
          }
        }
      ],
      meta:{
        requireAuth: true
      }
    },
    {
      path: '/change_requests',
      name: 'change_requests',
      component: () => import('./views/Documents.vue'),
      children: [
        {
          path: 'change_requests_search',
          name: 'change_requests_search',
          component: () => import ('./views/Documents/Search.vue'),
          meta:{
            requireAuth: true,
            parent: 'change_requests',
            type: 'approved',
            query: {
              tasksheet: true,
            },
          }
        },
        {
          path: 'change_requests_last_month',
          name: 'change_requests_last_month',
          component: () => import ('./views/Documents/Search.vue'),
          meta:{
            requireAuth: true,
            parent: 'change_requests',
            type: 'approved',
            query: {
              tasksheet: true,
              last_month: true,
            },
          }
        },
        {
          path: 'change_requests_list_by',
          name: 'change_requests_list_by',
          component: () => import ('./views/Documents/Search.vue'),
          meta:{
            requireAuth: true,
            parent: 'change_requests',
            type: 'approved',
            query: {
              tasksheet: true,
              list_by: true,
            },
          }
        },
      ],
      meta:{
        requireAuth: true
      }
    },
    {
      path: '/documents',
      name: 'documents',
      component: () => import ('./views/Documents.vue'),
      children: [
        {
          path: 'payment_summary/:id', // NS-9511 DL - new functionality for online payments
          name: 'payment_summary',
          component: () => import ('./views/PaymentSummary.vue'),
          props: true,
          meta: {
            requireAuth: true,
            parent: 'documents'
          }
        },
        {
          path: 'search',
          name: 'documents_search',
          component: () => import ('./views/Documents/Search.vue'),
          meta:{
            requireAuth: true,
            parent: 'documents',
            // EIPP-463 delete default status
            // type: 'approved'
          }
        },
        {
          path: 'online_statements',
          name: 'online_statements',
          component: () => import ('./views/Documents/Search.vue'),
          meta:{
            requireAuth: true,
            parent: 'documents',
            type: 'approved',
            query: {
              online_statements: true,
            },
          }
        },
        {
          path: 'docs_last_month',
          name: 'docs_last_month',
          component: () => import ('./views/Documents/Search.vue'),
          meta: {
            requireAuth: true,
            parent: 'documents',
            type: 'approved',
            query: {
              last_month: true,
            },
          }
        },
        {
          path: 'proof',
          name: 'proof',
          component: () => import ('./views/Documents/Search.vue'),
          meta:{
            requireAuth: true,
            parent: 'documents',
            type: 'proof'
          }
        },
      ],
      meta:{
        requireAuth: true
      }
    },
    {
      path: '/document/view/:type/:id/:watermark?',
      name: 'view_document',
      component: () => import ('./views/Documents/ViewDocument.vue'),
      meta:{
        requireAuth: true,
        parent: 'documents'
      }
    },
    // EIPP-755 Access to document via token/hash, PW
    {
      path: '/document_viewer/:doc_id/:token',
      name: 'document_viewer',
      component: () => import ('./views/Documents/HashDocumentView.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/document_creation_management',
      name: 'document_creation_management',
      component: () => import ('./views/DocumentCreationManagement.vue'),
      children: [
        {
          path: 'manage_batches',
          name: 'manage_batches',
          component: () => import ('./views/ManageBatches.vue'),
          props: (route) => ({
            page: route.query.page,
            per_page: route.query.per_page,
            batch_ref: route.query.batch_ref,
            batch_id: route.query.batch_id,
            upload_after : route.query.upload_after,
            upload_before : route.query.upload_before,
            batch_type: route.query.batch_type,
            batch_status: route.query.batch_status,
            sub_batch_name: route.query.sub_batch_name,
            invoice_from: route.query.invoice_from,
            invoice_to: route.query.invoice_to,
            invoice_number: route.query.invoice_number,
            customer_number: route.query.customer_number
          }),
          meta:{
            requireAuth: true,
            redirect: false,
            parent: 'document_creation_management'
          }
        },
        {
          path: 'manage_batches/batch_status',
          name: 'batch_status',
          component: () => import ('./views/BatchStatus.vue'),
          props: (route) => ({
            page: route.query.page,
            per_page: route.query.per_page,
            batch_id: route.query.batch_id,
            batch_ref: route.query.batch_ref,
            batch_type: route.query.batch_type,
            batch_status: route.query.batch_status,
            upload_after : route.query.upload_after,
            upload_before : route.query.upload_before
          }),
          meta:{
            parent: 'manage_batches',
            requireAuth: true
          }
        },
        {
          path: 'manage_batches/batch',
          name: 'batch',
          component: () => import ('./views/Batch.vue'),
          meta:{
            parent: 'manage_batches',
            requireAuth: true
          }
        },
        {
          path: 'manage_batches/batch/insert',
          name: 'batch_insert',
          component: () => import ('./views/BatchInsert.vue'),
          /*
          props: (route) => ({
            batch: route.query.batch
          }),*/
          meta:{
            parent: 'manage_batches',
            requireAuth: true
          }
        },
        {
          path: 'manage_batches/batch_status',
          name: 'batch_status',
          component: () => import ('./views/BatchStatus.vue'),
          props: (route) => ({
            page: route.query.page,
            per_page: route.query.per_page,
            batch_id: route.query.batch_id,
            batch_ref: route.query.batch_ref,
            batch_type: route.query.batch_type,
            batch_status: route.query.batch_status,
            upload_after : route.query.upload_after,
            upload_before : route.query.upload_before
          })
        },
        {
          path: 'broadcast_messages',
          name: 'broadcast_messages',
          component: () => import ('./views/BroadcastMessage.vue'),
          meta:{
            requireAuth: true,
            destination: 'broadcastMsg'
          }
        },
        {
          path: 'manage_mailsort',
          name: 'manage_mailsort',
          component: () => import ('./views/ManageMailsort.vue'),
          meta: {
            requireAuth: true,
            destination: 'batcheMailsort'
          }
        }
      ],
      meta:{
        requireAuth: true
      }
    },
    {
      path: '/reporting',
      name: 'reporting',
      component: () => import ('./views/Reporting.vue'),
      children: [
        {
          path: 'send_exceptions',
          name: 'send_exceptions',
          component: () => import ('./views/SendExceptions.vue'),
          meta:{
            requireAuth: true
          }
        },
        {
          path: 'whosonline',
          name: 'whosonline',
          component: () => import ('./views/WhoIsOnline.vue'),
          meta:{
            requireAuth: true
          }
        },
        {
          path: 'delivery_reports',
          name: 'delivery_reports',
          component: () => import ('./views/DeliveryReports.vue'),
          meta:{
            requireAuth: true
          }
        },
        {
          path: 'disputes',
          name: 'disputes',
          component: () => import ('./views/Disputes.vue'),
          meta:{
            requireAuth: true
          }
        },
        {
          path: 'view_logs',
          name: 'view_logs',
          component: () => import ('./views/ViewLogs.vue'),
          props: (route) => ({
            page: route.query.page,
            per_page: route.query.per_page,
            log_type: route.query.log_type,
            date_from: route.query.date_from,
            date_to: route.query.date_to,
            ip: route.query.ip,
            email: route.query.email,
            account: route.query.account,
            user: route.query.user,
            customer: route.query.customer
          }),
          meta:{
            requireAuth: true
          }
        },
        {
          path: 'import_data_file',
          name: 'import_data_file',
          component: () => import ('./views/ImportDataFile.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'KPI',
          name: 'kpi',
          component: () => import('./views/Statistics/KPI.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'netsend_billing_data',
          name: 'netsend_billing_data',
          component: () => import('./views/BillingData.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'customer_send_methods',
          name: 'customerSendMethods',
          component: () => import ('./views/Reporting/CustomerSendMethods.vue'),
          meta:{
            requireAuth: true
          }
        }
      ],
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/no_access',
      name: 'no_access',
      component: () => import ('./views/NoAccess.vue')
    },
    {
      path: '/delete_documents',
      name: 'delete_documents',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'documentsDeletion'
      }
    },
    {
      path: '/batch_actions',
      name: 'batch_actions',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'batchActions'
      }
    },
    {
      path: '/upload_images',
      name: 'upload_images',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'documents/add_bulk'
      }
    },
    {
      path: '/upload_images_via_ftp',
      name: 'upload_images_via_ftp',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'documents/add_ftp'
      }
    },
    {
      path: '/duplicate_documents',
      name: 'duplicate_documents',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'documents/duplicate'
      }
    },
    {
      path: '/document_progress_report',
      name: 'document_progress_report',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'dashboard/documentProgress'
      }
    },
    {
      path: '/add_coversheet_settings',
      name: 'add_coversheet_settings',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'variableCoversheetSettings'
      }
    },
    {
      path: '/dashboard_activity',
      name: 'dashboard_activity',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'dashboard/activity'
      }
    },
    // Moved to Customers/Accounts
    /*
    {
      path: '/principal_management',
      name: 'principal_management',
      component: () => import('./views/PrincipalManagement.vue'),
      meta:{
          requireAuth: true
      }
    },*/
    {
      path: '/splitter_management',
      name: 'splitter_management',
      component: () => import('./views/Portal.vue'),
      meta:{
          requireAuth: true
      }
    },
    // Posting
    {
      path: '/posting',
      name: 'posting',
      component: () => import ('./views/Posting/Index'),
      children: [
        {
          path: 'track',
          name: 'posting_track',
          component: () => import ('./views/Posting/PostingTrack'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'postage_cost',
          name: 'postage_cost',
          component: () => import ('./views/Posting/PostageCost'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'postage_discount',
          name: 'postage_discount',
          component: () => import ('./views/Posting/PostageDiscount'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'envelope_selling_price',
          name: 'envelope_selling_price',
          component: () => import ('./views/Posting/EnvelopeSellingPrice'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'envelope_type',
          name: 'envelope_type',
          component: () => import ('./views/Posting/EnvelopeType'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'postage_selling_price',
          name: 'postage_selling_price',
          component: () => import ('./views/Posting/PostageSellingPrice'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'envelope_cost',
          name: 'envelope_cost',
          component: () => import ('./views/Posting/EnvelopeCost'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'posting_free_text',
          name: 'posting_free_text',
          component: () => import ('./views/Posting/PostingFreeText'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'daily_posting_tallies',
          name: 'daily_posting_tallies',
          component: () => import ('./views/Posting/PostingDailyTallies'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'posting_summary',
          name: 'posting_summary',
          component: () => import ('./views/Posting/PostingSummary'),
          meta: {
            requireAuth: true
          }
        },
      ]
    },
    // settings
    {
      path: '/customers_accounts',
      name: 'customers_accounts',
      component: () => import ('./views/Customers_Accounts.vue'),
      children : [
        {
          path: 'transfer_customers',
          name: 'transfer_customers',
          component: () => import ('./views/TransferCustomers.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'manage_customers',
          name: 'manage_customers',
          component: () => import ('./views/ManageCustomers.vue'),
          meta: {
            requireAuth: true
          }
        },
        /*
        {
          path: 'transfer_customers',
          name: 'transfer_customers',
          component: () => import ('./views/TransferCustomers.vue'),
          meta: {
            requireAuth: true
          }
        },*/
        {
          path: 'customer/details/:id',
          component: () => import('./views/CustomerView.vue'),
          name: 'customer_view',
          meta: {
            requireAuth: true,
            parent: 'manage_customers'
          }
        },
        {
          path: 'customers/deliveryOptions/:id',
          component: () => import('./views/CustomerDeliveryOptions.vue'),
          name: 'customer_delivery_options',
          meta: {
            requireAuth: true,
            parent: 'manage_customers'
          }
        },
        {
          path: 'customers/userDeliveryOptions/:customer/:id',
          component: () => import('./views/CustomerUserDeliveryOptions.vue'),
          name: 'customer_user_delivery_options',
          meta: {
            requireAuth: true,
            parent: 'manage_customers'
          }
        },
        {
          path: 'customers/coversheets/:id',
          component: () => import('./views/CustomerCoversheets.vue'),
          name: 'customer_coversheets',
          meta: {
            requireAuth: true,
            parent: 'manage_customers'
          }
        },
        {
          path: '/customer_users',
          name: 'manage_end_users',
          component: () => import ('./views/ManageEndUsersView.vue'),
          meta:{
            requireAuth: true,
            parent: 'manage_customers'
          }
        },
        {
          path: 'principal_management',
          name: 'principal_management',
          component: () => import('./views/PrincipalManagement.vue'),
          meta:{
              requireAuth: true
          }
        },
        {
          path: '/manage_admin_logins',
          name: 'manage_admin_logins',
          component: () => import ('./views/ManageAdminLoginsView.vue'),
          meta:{
            requireAuth: true,
            parent: 'manage_customers'
          }
        },
        {
          path: 'manage_registration_request',
          name: 'manage_registration_request',
          component: () => import ('./views/ManageRegistrationRequest.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'add_customers_bulk',
          name: 'add_customers_bulk',
          component: () => import ('./views/AddCustomers/AddCustomers.vue'),
          meta:{
            requireAuth: true
          }
        },
        {
          path: 'add_customers_bulk_managed_ar',
          name: 'add_customers_bulk_managed_ar',
          component: () => import ('./views/AddCustomers/AddCustomersAR.vue'),
          meta:{
            requireAuth: true
          }
        },
        {
          path: 'add_customers',
          name: 'add_customers',
          component: () => import ('./views/AddCustomer.vue'),
          meta:{
            requireAuth: true
          }
        },
        {
          path: 'blacklist_users',
          name: 'blacklist_users',
          component: () => import ('./views/BlacklistUsers.vue'),
          meta:{
            requireAuth: true
          }
        },
        {
          path: '/customer_send_options',
          name: 'customer_send_options',
          component: () => import ('./views/CustomerSendOptions.vue'),
          meta: {
            requireAuth: true
          }
        },
      ],
      meta: {
        requireAuth: true
      }
    },
    /*{
      path: '/users/customer_users',
      name: 'manage_end_users',
      component: () => import ('./views/CustomerUsersView.vue'),
      meta:{
        requireAuth: true,
        //redirect: true,
        //destination: 'users/customer_users'
      }
    },*/
    {
      path: '/fax_status',
      name: 'fax_status',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'utils/fax_status'
      }
    },
    {
      path: '/email_status',
      name: 'email_status',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'utils/email_status'
      }
    },
    {
      path: '/download_customers_backup',
      name: 'download_customers_backup',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'downloadBackup/customers'
      }
    },
    {
      path: '/download_users_backup',
      name: 'download_users_backup',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'downloadBackup/users'
      }
    },
    {
      path: '/retrieve_pdfs',
      name: 'retrieve_pdfs',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'retrievePDFs'
      }
    },
    // settings
    {
      path: '/settings',
      name: 'settings',
      component: () => import ('./views/Settings.vue'),
      children : [
        {
          path: 'token_translation',
          name: 'token_translation',
          component: () => import ('./views/TokenTranslation.vue'),
          meta:{
            requireAuth: true
          }
        },
        {
          path: 'site_setup',
          name: 'site_setup',
          component: () => import ('./views/SiteSetup.vue'),
          meta:{
            requireAuth: true
          }
        },
        {
          path: 'menu_builder',
          name: 'menu_builder',
          component: () => import ('./views/MenuBuilder.vue'),
          meta:{
            requireAuth: true
          }
        },
        {
          path: 'edit_languages',
          name: 'edit_languages',
          component: () => import ('./views/EditLanguages.vue'),
          meta:{
            requireAuth: true
          }
        },
        {
          path: 'client_configuration',
          name: 'client_configuration',
          component: () => import ('./views/ClientConfiguration.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'client_configuration/add_business_unit',
          name: 'add_business_unit',
          component: () => import ('./views/AddBusinessUnit.vue'),
          meta: {
            requireAuth: true,
            parent: 'client_configuration'
          }
        },
        {
          path: 'client_configuration/:id',
          component: () => import('./views/BusinessUnit.vue'),
          name: 'business_unit',
          meta: {
            requireAuth: true,
            parent: 'client_configuration'
          }
        },
        {
          path: '/document_type_mapping',
          name: 'document_type_mapping',
          component: () => import ('./views/documentTypeMapping.vue'),
          meta:{
            requireAuth: true
          }
        },
        {
          path: 'batch_rules',
          name: 'batch_rules',
          component: () => import ('./views/BatchRules.vue'),
          meta:{
            requireAuth: true
          }
        },
        {
          path: '/email_variables',
          name: 'email_variables',
          component: () => import ('./views/EmailVariables.vue'),
          meta:{
            requireAuth: true,
          }
        },
        {
          path: 'add_customer',
          component: () => import('./views/AddCustomer.vue'),
          name: 'add_customer',
          meta: {
            requireAuth: true
          }
        },
        {
          //ALL-9834 RR
          path: 'client_delivery_rules',
          component: () => import('./views/ClientDeliveryRules.vue'),
          name: 'client_delivery_rules',
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'edit_email_notifications',
          name: 'edit_email_notifications',
          component: () => import ('./views/EditEmailNotifications.vue'),
          meta:{
            requireAuth: true
          }
        },
        {
          path: 'account_settings',
          name: 'account_settings',
          component: () => import ('./views/AccountSettings.vue'),
          meta:{
            requireAuth: true
          }
        },
        {
          path: 'client_settings',
          name: 'client_settings',
          component: () => import ('./views/ClientSettings/ClientSettings.vue'),
          meta:{
            requireAuth: true
          }
        },
      ],
      meta:{
        requireAuth: true
      }
    },
    // Invoicing
    {
      path: '/invoicing',
      name: 'invoicing',
      component: () => import ('./views/Invoicing/Index'),
      children: [
        {
          path: 'track',
          name: 'invoicing_track',
          component: () => import ('./views/Invoicing/Track'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'report',
          name: 'invoicing_report',
          component: () => import ('./views/Invoicing/Report'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'set_document_storage_cost',
          name: 'set_document_storage_cost',
          component: () => import ('./views/Invoicing/SetDocumentStorageCost.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'set_invoicing_rule',
          name: 'set_invoicing_rule',
          component: () => import ('./views/Invoicing/SetRule'),
          meta:{
            requireAuth: true,
          }
        },
        {
          path: 'invoices_to_do',
          name: 'invoices_to_do',
          component: () => import ('./views/Invoicing/ToDo.vue'),
          meta:{
            requireAuth: true,
          }
        },
        {
          path: 'invoices_completed',
          name: 'invoices_completed',
          component: () => import ('./views/Invoicing/Completed.vue'),
          meta:{
            requireAuth: true,
          }
        },
        {
          path: 'invoices_queried',
          name: 'invoices_queried',
          component: () => import ('./views/Invoicing/Queried.vue'),
          meta:{
            requireAuth: true,
          }
        },
        {
          path: 'free_text_invoice_to_do',
          name: 'free_text_invoice_to_do',
          component: () => import ('./views/Invoicing/FreeTextToDo'),
          meta:{
            requireAuth: true,
          }
        },
        {
          path: '/free_text_invoice_completed',
          name: 'free_text_invoice_completed',
          component: () => import ('./views/Invoicing/FreeTextCompleted'),
          meta:{
            requireAuth: true,
          }
        },
        {
          path: '/free_text_invoice_queried',
          name: 'free_text_invoice_queried',
          component: () => import ('./views/Invoicing/FreeTextQueried'),
          meta:{
            requireAuth: true,
          }
        },
        {
          path: '/add_free_text_invoice',
          name: 'add_free_text_invoice',
          component: () => import ('./views/Invoicing/AddFreeTextInvoice'),
          meta:{
            requireAuth: true,
          }
        },
      ]
    },
    {
      path: '/faq/:id/:filename',
      name: 'website_faq',
      component: () => import ('./components/Site_setup/SiteSetupFAQInfoPdf.vue'),
      meta:{
        requireAuth: true,
        parent: 'portal'
      }
    },
    {
      path: '/document_creation_management/manage_batches',
      name: 'insert',
      component: () => import ('./views/ManageBatches.vue'),
      props: (route) => ({
        page: route.query.page,
        per_page: route.query.per_page,
        batch_ref: route.query.batch_ref,
        batch_id: route.query.batch_id,
        upload_after : route.query.upload_after,
        upload_before : route.query.upload_before,
        batch_type: route.query.batch_type,
        batch_status: route.query.batch_status,
        sub_batch_name: route.query.sub_batch_name,
        invoice_from: route.query.invoice_from,
        invoice_to: route.query.invoice_to,
        invoice_number: route.query.invoice_number,
        customer_number: route.query.customer_number
      }),
      meta:{
        requireAuth: true,
        redirect: false,
        parent: 'document_creation_management'
      }
    },
    {
      path: '/businessUnit/:businessUnit',
      name: 'set_business_unit',
      component: () => import ('./components/Helper_Components/SetBusinessUnit.vue'),
      meta: {
        requireAuth: false,
        allowRedirection: false
      }
    },
    {
      path: '/dashboard_settings',
      name: 'dashboard_settings',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'dashboard/settings'
      }
    },
    {
      path: '/principals_delivery_report_rules',
      name: 'principals_delivery_report_rules',
      component: () => import ('./views/PrincipalsReportDeliveryRules.vue'),
      meta: {
        requireAuth: true,
        redirect: false,
        destination: 'principalReports'
      }
    },
    /*{
      path: '/client_delivery_rules',
      name: 'client_delivery_rules',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'rules/client_delivery_rules'
      }
    },*/
    {
      path: '/generic_template_editor',
      name: 'generic_template_editor',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'documentDesigner/documentGenericEditor'
      }
    },
    {
      path: '/document_designer',
      name: 'document_designer',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'documentDesigner/main'
      }
    },
    {
      path: '/document_editor',
      name: 'document_editor',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'documentDesigner/documentEditor'
      }
    },

    {
      path: '/document_convertor',
      name: 'document_convertor',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'documentConverter/main'
      }
    },
    {
      path: '/document_generator',
      name: 'document_generator',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'documentGenerator/main'
      }
    },
    // netsend
    {
      path: '/generate_invoice',
      name: 'generate_invoice',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'invoicing/generate_invoice?step=1'
      }
    },
    {
      path: '/other_invoices',
      name: 'other_invoices',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'invoicing/doc_invoice'
      }
    },
    {
      path: '/set_document_storage_cost',
      name: 'set_document_storage_cost',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'invoicing/set_storage_cost'
      }
    },
    {
      path: '/set_charge_rates',
      name: 'set_charge_rates',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'invoicing/set_charge_rule'
      }
    },
    {
      path: '/maintenance',
      name: 'maintenance',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'maintenance'
      }
    },
    /*
    {
      path: '/core_types',
      name: 'core_types',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'coreTypes'
      }
    },
    */
    {
      path: '/dunning_configuration',
      name: 'dunning_configuration',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'dunningConfiguration'
      }
    },
    {
      path: '/system_statistics',
      name: 'system_statistics',
      component: () => import ('./views/Portal.vue'),
      meta:{
        requireAuth: true,
        redirect: true,
        destination: 'system'
      }
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import ('./views/Profile.vue'),
      meta:{
        requireAuth: true
      }
    },
    {
      path: '/acknowledge_msg',
      name: 'acknowledge_msg',
      component: () => import ('./components/Helper_Components/AcknowledgeMsg.vue'),
      meta: {
        requireAuth: true,
        redirect: false,
        allowRedirection: false
      }
    },
    {
      path: '/login/sso/:token',
      name: 'ssoLogin',
      component: () => import ('./views/sso/SsoLogin.vue'),
      meta:{
        requireAuth: false
      }
    },
    // EIPP-114 added business unit parameter
    {
      path: '/login/v1/:token/:business_unit?',
      name: 'externalLogin',
      component: () => import ('./views/Helpers/ExternalLogin.vue'),
      meta:{
        requireAuth: false
      }
    },
    {
      path: '/site_unavailable',
      name: 'site_unavailable',
      component: () => import('./views/403.vue'),
      meta: {
        requireAuth: false,
        allowRedirection: false
      }
    },
    {
      path: '/redirect/:destination',
      name: 'redirect',
      component: () => import('./views/Redirect.vue'),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '*',
      name: '404 Not Found',
      component: () => import('./views/PageNotFound.vue'),
      meta:{
        requireAuth: false
      }
    }
  ]
})

/**
  * router
  * store.dispatch('loginWithToken').then was used to assure the data is set. if not the data is gonna be called.
  * 1. Redirect user to portal if going to login page and user is already logged in
  * 2. Check if a page requires authentication (meta:{requireAuth: true})
  * 3. Check if user has access to a specific level
  * 4. Check if name of destination is 'disable' do not allow clicking
*/
router.beforeEach((to, from, next) => {
    // because validation msgs are permanent we have to make sure they are cleared while switching components
    store.dispatch('alertClearErrors')

    // NS-9956 this will let us access sso with totaprod portal
    let urlAddress = window.location.host
    let urlParts = urlAddress.split('.')
    let clientUrlName = urlParts[0]

    // tota only functionality to make sure user is redirected to the SSO Login page in case he/she isnt already logged in
    // allowedSsoRoutes makes sure user is not redirected to the login page when accessing one of those routes while not logged in
    let allowedSsoRoutes = ['ssoLogin', 'ssoRegistration', 'user_exists', 'ssoRegistrationSuccess', 'ssoAlreadyRegistered', 'newsnetLogin']
    if((clientShortName() == 'tota' || clientShortName() == 'totatest' || clientUrlName == 'totaprod') && !store.getters.loggedIn && vuecookie.get('token') != '' && allowedSsoRoutes.indexOf(to.name) == -1) {
      window.location.replace(`${backendUrl()}` + '/sso')

      return
    }

    if (store.getters.loggedIn && to.meta.requireAuth == false) {
      if(to.meta.allowRedirection == false) {
        next()
      } else {
        next({
          path: '/portal'
        })
      }
    }

    if (to.matched.some(record => record.meta.requireAuth)) {
        if (!store.getters.loggedIn) {
          vuecookie.remove('token')
          localStorage.setItem('destination', to.fullPath)
          next({
            path: '/'
          })
        } else {
            if (typeof store.getters.getAllowedNavs == 'undefined' && to.meta.requireAuth == true) {
                if(vuecookie.get('token') != '') {
                  store.dispatch('loginWithToken').then(() => {
                    if(!store.getters.getAllowedNavs.includes(to.name) && !store.getters.getAllowedNavs.includes(to.meta.parent) && to.name != 'redirect') {
                      next({
                          path: '/no_access'
                        })
                    } else {
                      if(to.meta.redirect) {
                        router.push({ name: 'redirect', params: { destination: to.meta.destination}})
                      } else {
                        next()
                      }
                    }
                  }).catch(err => {
                    // EIPP-316 Handling fix, PW
                    if((err.status && err.status == 401) || (err.response.status && err.response.status == 401)) {
                      store.dispatch('handleTokenExpiration')
                    } else if(err.status && err.status == 503) {
                      store.dispatch('handleTokenExpiration')
                      router.push('/site_unavailable')
                    }
                  })
                } else {
                  next({
                    path: '/no_access'
                  })
                }
            } else {
                if(!store.getters.getAllowedNavs.includes(to.name) && !store.getters.getAllowedNavs.includes(to.meta.parent) && to.name != 'redirect') {
                    next({
                      path: '/no_access'
                    })
                } else {
                  // update last request time on every route change
                  store.dispatch('updateLastRequest').then(response => {
                    if (response && response.data.status && response.data.status === 'success') {
                      if (to.name !== from.name) {
                        store.dispatch('updateQuickLinks', to.name)
                      }
                    }
                  })

                  if (to.meta.redirect) {
                    router.push({ name: 'redirect', params: { destination: to.meta.destination}})
                  } else {
                    next()
                  }
                }
            }
        }
    } else if (to.name == 'disable') {
      next({
        path: from.path
      })
    } else {
      next()
    }
})

router.afterEach((to, from) => {
  if (to.meta.requireAuth == true && vuecookie.get('token') == 'undefined') {
    router.push({name: 'no_access'})
  }
})

export default router
